import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import API from '../../tools/API';
import style from './Login.module.scss';
import Modal from '../../components/Modal/Modal';

const Login = () => {
    const navigate = useNavigate();
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [remember, setRemember] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [modalText, setModalText] = useState('');

    const loggIn = () => {
        if (login && password) {
            setModalText('');
            API.logIn(login, password, remember).then(res => {
                if (res.status === 200) {
                    window.localStorage.setItem('user', JSON.stringify(res.data.data));
                    navigate('/');
                }
            }).catch(err => {
                if (err.status !== 200) {
                    setModalText(err.response.data.exception);
                    setShowModal(true);
                }
            })
        } else {
            setModalText('Musisz wpisać login i hasło');
            setShowModal(true);
        }

    }

    const LoggInByEnter = (e: React.KeyboardEvent) => {
        if (e.code === 'Enter') {
            loggIn();
        }
    }

    return (
        <>
            <section className={style.login}>
                <div className={style.login__container}>
                    <form className={style.login__form} onKeyDown={(e) => LoggInByEnter(e)}>
                        <input
                            type="text"
                            name="login"
                            id="login"
                            placeholder='login'
                            className={style.login__formInput}
                            value={login}
                            onChange={(e) => {
                                setLogin(e.target.value)
                            }}
                        />
                        <input
                            type="password"
                            name="password"
                            id="password"
                            placeholder='hasło'
                            className={style.login__formInput}
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value)
                            }}
                        />
                        <div className={style.rememberBox}>
                            <input
                                type="checkbox"
                                id="rememberMe"
                                name="rememberMe"
                                className={style.login__checkbox}
                                checked={remember}
                                onChange={(e) => {
                                    setRemember(e.target.checked)
                                }}
                            />
                            <span className={style.checkmark}></span>
                            <label
                                htmlFor="rememberMe"
                                className={style.login__formLabel}
                            >
                                Zapamiętaj mnie
                            </label>

                        </div>
                        <input
                            type="button"
                            value="Zaloguj"
                            className={style.login__formButton}
                            onClick={(e) => {
                                e.preventDefault();
                                loggIn();
                            }}
                        />
                    </form>
                </div>
            </section>
            {showModal && (
                <Modal
                    text={modalText}
                    openModal={setShowModal}
                />
            )}

        </>
    )
}

export default Login